import type { HazardType, Severity } from '../../types/cap'
import { HAZARD_COLORS, HAZARD_LABELS, HAZARD_ICONS } from '../../types/cap'

interface HazardBadgeProps {
  hazardType: HazardType
  className?: string
}

const SEVERITY_STYLES: Record<Severity, string> = {
  Extreme: 'bg-red-600/20 text-red-400 border-red-600/40',
  Severe: 'bg-orange-500/20 text-orange-400 border-orange-500/40',
  Moderate: 'bg-yellow-500/20 text-yellow-300 border-yellow-500/40',
  Minor: 'bg-blue-500/20 text-blue-300 border-blue-500/40',
  Unknown: 'bg-gray-600/20 text-gray-400 border-gray-600/40',
}

interface SeverityBadgeProps {
  severity: Severity | null | undefined
  className?: string
}

export function HazardBadge({ hazardType, className = '' }: HazardBadgeProps) {
  const color = HAZARD_COLORS[hazardType]
  const label = HAZARD_LABELS[hazardType]
  const icon = HAZARD_ICONS[hazardType]
  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium border ${className}`}
      style={{ color, borderColor: color + '66', backgroundColor: color + '1a' }}
    >
      <span>{icon}</span>
      {label}
    </span>
  )
}

export function SeverityBadge({ severity, className = '' }: SeverityBadgeProps) {
  if (!severity) return null
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border ${SEVERITY_STYLES[severity]} ${className}`}
    >
      {severity}
    </span>
  )
}

interface PriorityDotProps {
  score: number
  className?: string
}

export function PriorityDot({ score, className = '' }: PriorityDotProps) {
  const colors = ['', 'bg-gray-500', 'bg-blue-500', 'bg-yellow-500', 'bg-orange-500', 'bg-red-500']
  const color = colors[Math.min(score, 5)] ?? 'bg-gray-500'
  return (
    <span
      className={`relative inline-flex h-2.5 w-2.5 rounded-full ${color} ${score === 5 ? 'priority-pulse' : ''} ${className}`}
      title={`Priority ${score}`}
    />
  )
}
